<template>
    <div class="wrapper" ref="wrapper">
        <div class="content">
            <template v-if="!isDailyFree">
                <CategoryItem 
                    @click.native="clickItem(item.channelId, item.courseId, item.videoStatus, item.bought, item.free)"
                    v-for="item in category"
                    :key="item.channelId"
                    :has-auth="item.bought"
                    :title="item.name"
                    :course-type="item.videoStatus"
                    :trial="item.previewVideo"
                    :playtime="item.playtime"
                    :duration="item.duration"
                    :class="{'item-active':item.channelId==currentItem}"
                    :channelId="item.channelId"
                ></CategoryItem>
            </template>
            <template v-else>
                <DailyFreeItem
                    @click.native="clickItem(item.channelId, item.courseId, item.videoStatus, item.bought, item.free)" 
                    v-for="item in category" :key="item.channelId" :img-url="item.recordImgUrl" :name="item.name"
                    :start-time="item.liveStartTime"
                    :channelId="item.channelId"
                    :class="{'item-active':item.channelId==currentItem}"
                    :viewer-count="item.viewerCount" />
            </template>
        </div>
    </div>
</template>

<script>
    import CategoryItem from '@/components/CategoryItem';
    import DailyFreeItem from '@/components/DailyFreeItem';
    import BScroll from 'better-scroll';
    import {  getCourseList, refreshTime } from '@/utils/http';
    import { mapState } from 'vuex';
    export default {
        props: {
            isDailyFree: {
                type: Boolean
            },
            currentPlayTime: {
                type: Number
            },
            currentItem: {
                type: String
            }
        },
        data() {
            return {
                page: 1,
                pageSize: 10,
                category: [],
                hadLoadAll: false,
                isRequesting: false
            }
        },
        components: {
            CategoryItem,
            DailyFreeItem
        },
        computed: {
            ...mapState(['ct', 'ut'])
        },
        mounted() {
            this.initCourseList();
            this.$nextTick(() => {
            //$refs绑定元素
                if(!this.scroll){
                    this.scroll = new BScroll(this.$refs.wrapper, {
                    //开启点击事件 默认为false
                        click:true,
                    })
                    this.scroll.on('touchEnd', pos => {
                        if (this.hadLoadAll || this.isRequesting) {
                            return;
                        }
                        if (pos.y - this.scroll.maxScrollY < 200) {
                            this.page++;
                            this.initCourseList();
                        }
                    })
                }else if(!this.$refs.wrapper){
                    return
                }
                else{
                    this.scroll.refresh()
                }
            })
        },
        methods: {
            initCourseList() {
                this.isRequesting = true;
                const dailyFree = this.$route.query.type == -1 || this.$route.query.type == -3;
                getCourseList({
                    courseId: this.$route.query.courseId,
                    pageNum: this.page,
                    pageSize: this.pageSize,
                    ctoken: dailyFree ? '' : this.ct,
                    utoken: dailyFree ? '' : this.ut
                }).then(json => {
                    this.isRequesting = false;
                    const res = json.data;
                    if (res.code == 0) {
                        if (res.data.length) {
                            this.category = [...this.category, ...res.data];
                            this.$nextTick(() => {
                                this.scroll.refresh()
                            })
                        } else {
                            this.hadLoadAll = true;
                        }
                    }
                })
            },
            clickItem(channelId, courseId, status, bought, free) {
                if (channelId == this.$route.query.channelId && bought) {
                    return;
                }
                for (let i = 0; i < this.category.length; i++) {
                    if (this.category[i].channelId == this.$route.query.channelId) {
                        this.category[i].playtime = this.currentPlayTime;
                        break;
                    }
                }
                this.$emit('on-video-click', {
                    channelId,
                    courseId,
                    status,
                    bought,
                    free
                })
                
            }
        }
    }
</script>

<style  scoped>
.wrapper{
  width: 100%;
  height: 100%;
  /* position: absolute; */
  overflow: hidden;
  z-index: 1;
}
.item-active {
    background: #f9f6f6;
}
</style>